export const ACTION = {
  FETCH_ASSET_EVENTS_REPORT: 'FETCH_ASSET_EVENTS_REPORT',
  HANDLE_FETCH_ASSET_EVENTS_REPORT: 'HANDLE_FETCH_ASSET_EVENTS_REPORT',
  FETCH_SUMMARY_FIXED_ASSET_EVENTS: 'FETCH_SUMMARY_FIXED_ASSET_EVENTS',
  HANDLE_FETCH_SUMMARY_FIXED_ASSET_EVENTS: 'HANDLE_FETCH_SUMMARY_FIXED_ASSET_EVENTS',
}
